module.exports = __webpack_public_path__ + "static/frostbytes-8723bac05857b235f827172387cbfd64.mp4";